export default __webpack_public_path__ + "static/media/manolo-garcia.2fd24a02.webp";